var map = {
	"./en": 775,
	"./en.json": 775,
	"./fr": 776,
	"./fr.json": 776
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;


//////////////////
// WEBPACK FOOTER
// ./src/locales ^\.\/.*$
// module id = 214
// module chunks = 2